import { render } from "./MesMaterial.vue?vue&type=template&id=2af8bfde&scoped=true"
import script from "./MesMaterial.vue?vue&type=script&lang=js"
export * from "./MesMaterial.vue?vue&type=script&lang=js"

import "./MesMaterial.vue?vue&type=style&index=0&id=2af8bfde&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af8bfde"]])

export default __exports__